import script from "./select.vue?vue&type=script&lang=ts&setup=true"
export * from "./select.vue?vue&type=script&lang=ts&setup=true"

import "./select.vue?vue&type=style&index=0&id=189047fc&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189047fc"]])

export default __exports__